import {useState} from "react";
import {com} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";
import GetStripeUrlResponse = com.onkensu.platform.billing.GetStripeUrlResponse;

/**
 * This works for several rpc actions that redirect the provider to a stripe hosted page.
 * 

 * These take an empty request and redirect to the URL on finish.
 */
export const useGetStripeUrlLink = () => {

  const rpcSender = useRpcSender();

  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});
  
  const send = (method: string) => {

    setRpcState({state: 'pending'});
    rpcSender.send(method, new Uint8Array(0))
        .then(bytes => {
          const response = GetStripeUrlResponse.decode(bytes);
          setRpcState({state: 'success'})
          window.location.href = response.stripeUrl;
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error: ' + e.toString()});
        });
  }

  return {rpcState, send};
}